import { z } from 'zod'
import {
  DUEL_ERROR_CODES,
  DUEL_ERROR_TEXT,
  type DuelSnapshot,
  duelClientMessageSchema,
  duelRoomBodySchema,
  TURN_SECONDS_DEFAULT,
  turnSecondsSchema,
} from '../duel/protocol'
import type { CommonServerMessage, ErrorCode } from '../protocol'
import { C4_COLS, type C4State } from './engine'

// ---- room settings ----

export const c4SettingsSchema = z.object({ turnSeconds: turnSecondsSchema })
export type C4Settings = z.infer<typeof c4SettingsSchema>
export const c4SettingsPatchSchema = c4SettingsSchema.partial()
export type C4SettingsPatch = z.infer<typeof c4SettingsPatchSchema>
export const DEFAULT_C4_SETTINGS: C4Settings = { turnSeconds: TURN_SECONDS_DEFAULT }

/** Body of POST /api/c4/rooms. */
export const createC4RoomBodySchema = duelRoomBodySchema(c4SettingsPatchSchema)
export type CreateC4RoomBody = z.infer<typeof createC4RoomBodySchema>

export type C4Snapshot = DuelSnapshot<C4State, C4Settings>

// ---- client -> server ----

export const columnSchema = z
  .number()
  .int()
  .min(0)
  .max(C4_COLS - 1)

export const c4ClientMessageSchema = duelClientMessageSchema({ col: columnSchema })
export type C4ClientMessage = z.infer<typeof c4ClientMessageSchema>

// ---- server -> client ----

export const C4_ERROR_CODES = [...DUEL_ERROR_CODES, 'INVALID_COLUMN', 'COLUMN_FULL'] as const
export type C4ErrorCode = ErrorCode | (typeof C4_ERROR_CODES)[number]

export const C4_ERROR_TEXT: Record<(typeof C4_ERROR_CODES)[number], string> = {
  ...DUEL_ERROR_TEXT,
  INVALID_COLUMN: 'Invalid column',
  COLUMN_FULL: 'That column is full',
}

export type C4ServerMessage =
  | CommonServerMessage<C4ErrorCode>
  | { type: 'state'; snapshot: C4Snapshot }
